/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {COLORS} from "@res/colors";
import * as emotion from "emotion";
import {padding_rl_med} from "@styles/styles";
import {FONTS} from "@res/fonts";

type Props = {
	onClick?: (id: string) => void
	id?: string,
	bold?: boolean,
	content: string,
	color?: string
}

export class TableContent
	extends BaseComponent<Props, {}> {

	constructor(props: Props) {
		super(props);
	}

	rowStyle = () => {
		const textStyle = {color: this.props.color ? this.props.color : COLORS.neutral_text_dark, lineHeight: "25px"}; // line height should be at least half of row height for maximum of 2 lines
		const blockWithText = emotion.css({maxHeight: "47px"});
		const text = this.props.content &&
			(this.props.bold ? FONTS.semi_bold_16(this.props.content, textStyle) : FONTS.reg_16(this.props.content, textStyle));

		return <div
			className={`ll_h_c ${padding_rl_med}`}
			style={{height: 47, cursor: "pointer"}}
			onClick={() => {
				this.props.id && this.props.onClick && this.props.onClick(this.props.id);
			}}
		>
			<div className={blockWithText}>
				{text}
			</div>
		</div>;
	};


	render() {
		return this.rowStyle();
	}
}
